import * as actionTypes from './actionTypes';

export const authStart = () => {
    return {
        type: actionTypes.AUTH_START
    }
}

export const authSuccess = (token, user) => {
    return {
        type: actionTypes.AUTH_SUCCESS,
        idToken: token,
        user: user
    }
}

export const authFail = (error) => {
    return {
        type: actionTypes.AUTH_FAIL,
        error: error
    }
}

export const logout = () => {
    return {
        type: actionTypes.AUTH_INITIATE_LOGOUT
    }
}

export const logoutSucceed = () => {
    return {
        type: actionTypes.AUTH_LOGOUT
    }
}

export const auth = (username, password, region) => {
    return {
        type: actionTypes.AUTH_USER,
        username: username,
        password: password,
        region: region
    }
}

//checking if user is logged in or not on page refresh
export const authCheckState = () => {
    return {
        type: actionTypes.AUTH_CHECK_STATE
    }
}